import { render } from "./NewPayment.vue?vue&type=template&id=2ae15491"
import script from "./NewPayment.vue?vue&type=script&lang=js"
export * from "./NewPayment.vue?vue&type=script&lang=js"
script.render = render

export default script